import { Injectable, Type } from '@angular/core';
import { ApiResponse } from '@kinet-open-network/client/core/api-client';
import { BaseFlowsService } from '@kinet-open-network/client/flows/data-access';
import { mapToModel } from '@kinet-open-network/client/shared/data-access/model';
import { firstValueFrom, Observable } from 'rxjs';
import { FlowOrders, FlowOrdersStepData } from './flow-orders.model';

/**
 * Service for the "order" flow type.
 * Provides typed CRUD operations against `/flows/order`.
 *
 * Used by order flow stores in the feature shell.
 */
@Injectable({ providedIn: 'root' })
export class FlowOrdersService extends BaseFlowsService<
  FlowOrders,
  'id',
  FlowOrdersStepData
> {
  override readonly flowType = 'order';
  override model: Type<FlowOrders> = FlowOrders;
  override stepDataClass: Type<FlowOrdersStepData> = FlowOrdersStepData;

  override findOne(id: string): Observable<FlowOrders> {
    return this.http
      .get<
        ApiResponse<FlowOrders>
      >(`${this.endpoint}/${this.encodeId(id)}`, { params: { withDeleted: true } })
      .pipe(mapToModel(this.modelClass, 'data'));
  }

  getOrderFees(data: Record<string, any>): Observable<{ data: any[] }> {
    return this.http.post<{ data: any[] }>(`${this.endpoint}/get-fees`, data);
  }

  /** Generates a separate invoice for each of the given orders. */
  generateInvoices(orderIds: string[]) {
    return firstValueFrom(
      this.http.post<ApiResponse<FlowOrders[]>>(
        `${this.endpoint}/generate-invoices`,
        { orderIds },
      ),
    );
  }
}
